import React from 'react';

const DatasetViewerToolbar = ({
  isFullScreen,
  toggle,
  exportCSVFile,
  exportExcelFile,
  exportJSONFile,
  csvLoader,
  excelLoader,
  JSONLoader,
  studyPermission,
  setIsFullScreen
}) => {
  if (!isFullScreen) return null;

  const renderExportButton = (label, onClick, loading) => (
    <button
      onClick={onClick}
      className="updateProfile"
      type="button"
      disabled={loading}
    >
      {loading ? `↻ ${label}...` : label}
    </button>
  );

  return (
    <div className="d-flex flex-wrap align-items-center gap-2 border-bottom bg-white pb-2">
      <button className="updateProfile" type="button" onClick={() => toggle()}>Table Properties</button>
      {(studyPermission?.dbpAllAccess || studyPermission?.liveExtractDatasets || studyPermission?.qcExtractDatasets) ? (
        <>
          {renderExportButton('Download CSV', () => exportCSVFile(true), csvLoader)}
          {renderExportButton('Download Excel', () => exportExcelFile(true), excelLoader)}
          {renderExportButton('Download JSON', () => exportJSONFile(true), JSONLoader)}
        </>
      ) : (
        <>
          {renderExportButton('Download CSV', () => exportCSVFile(false), csvLoader)}
          {renderExportButton('Download Excel', () => exportExcelFile(false), excelLoader)}
          {renderExportButton('Download JSON', () => exportJSONFile(false), JSONLoader)}
        </>
      )}
      <div className="flex-grow-1"></div>
      <button className="removeProfile" type="button" onClick={() => setIsFullScreen(false)}>✕ Close Full Screen</button>
    </div>
  );
};

export default DatasetViewerToolbar;
